import { render } from "./SuperAdminSlowRoutes.vue?vue&type=template&id=2e5bf1b0&scoped=true"
import script from "./SuperAdminSlowRoutes.vue?vue&type=script&lang=js"
export * from "./SuperAdminSlowRoutes.vue?vue&type=script&lang=js"

import "./SuperAdminSlowRoutes.vue?vue&type=style&index=0&id=2e5bf1b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e5bf1b0"]])

export default __exports__